(function() {

  angular
    .module('meanApp')
    .factory('loginModal', ['$uibModal',
  function ($uibModal) {
    this.modalInstance = null;
    return {
      /**Will open the register or login function according to controller**/
        open : function(isLogin) {
            this.modalInstance = $uibModal.open({
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'auth/subscribe.view.html',
                controller: 'subscribeCtrl',
                controllerAs: 'vm',
                resolve : {
                    isLogin : isLogin
                }
            });
        },
        get : function() {
            return this.modalInstance;
        }
    };
  }]);

})();